import React from 'react';
import { formatMoney } from 'utils/storefront/format-resource';

const CartItemPrices = ({ item, cart, selectedVariant, isSaleItem }) => {
  return (
    <div className="flex gap-1">
      {item.original_line_price > item.line_price ? (
        <div className="body-3 line-through">
          {cart.mode === 'storefront'
            ? formatMoney(item.original_line_price || { amount: 0 })
            : formatMoney({ amount: item.original_line_price }, true)}
        </div>
      ) : (
        <>
          {parseFloat(selectedVariant?.compareAtPrice?.amount) * 100 > item.price && (
            <div className="body-3 line-through">
              {formatMoney(
                {
                  amount: parseFloat(selectedVariant.compareAtPrice.amount) * item.quantity,
                  currencyCode: selectedVariant?.compareAtPrice.currencyCode,
                },
                false,
              )}
            </div>
          )}
        </>
      )}
      <div className={`body-3 ${!!isSaleItem && 'text-error'}`}>
        {cart.mode === 'storefront'
          ? formatMoney(item.cost.totalAmount || { amount: 0 })
          : formatMoney({ amount: item.line_price }, true)}
      </div>
    </div>
  );
};

export default CartItemPrices;
